import { UserStore } from '@yarmill/types';

export function sortUserStoresByGroups(a: UserStore, b: UserStore): number {
  return a.groups.length - b.groups.length;
}
